module.exports = __webpack_public_path__ + "img/brochure.e804e455.png";